export default function getSelectedVariantName(): string {
  const variantSelector: HTMLFormElement | null = document.querySelector('form.variant-select');
  if (!variantSelector) {
    return '';
  }
  const radioInputElement = Array.from(variantSelector).find((radio) => (radio as HTMLInputElement).checked);
  const labelElement = radioInputElement?.nextElementSibling as HTMLLabelElement;
  const variantName = labelElement?.innerText || '';
  return variantName;
}
